module.exports = __webpack_public_path__ + "img/1054_help_title_en_7beeff255.png";